// CM: Mobile "sticky" bar for collection facets (Filtra e ordina + Product count)
// Robust: uses fixed + placeholder, and disables while any drawer/menu is open.
(() => {
  const mq = window.matchMedia('(max-width: 989px)');

  function init() {
    const bar = document.querySelector('.cm-mobile-sticky-bar');
    if (!bar) return;

    // Placeholder to prevent layout jump when bar becomes fixed
    let placeholder = document.querySelector('.cm-mobile-sticky-placeholder');
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'cm-mobile-sticky-placeholder';
      placeholder.style.height = '0px';
      bar.insertAdjacentElement('afterend', placeholder);
    }

    let startY = 0;

    const readHeaderBottom = () => {
      // Dawn updates this while scrolling
      const v = getComputedStyle(document.documentElement)
        .getPropertyValue('--header-bottom-position')
        .trim();

      const n = parseFloat(v);
      if (Number.isFinite(n)) return n;

      // Fallback to header height if available
      const vh = getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height')
        .trim();
      const nh = parseFloat(vh);
      return Number.isFinite(nh) ? nh : 0;
    };

    const computeStart = () => {
      const rect = bar.getBoundingClientRect();
      startY = rect.top + window.scrollY;
    };

    const anyDrawerOpen = () => {
      // Header menu, menu-drawer, cart-drawer, etc. usually use <details open>
      return !!document.querySelector(
        'header details[open], menu-drawer details[open], cart-drawer details[open]'
      );
    };

    const disableFixed = () => {
      if (bar.classList.contains('cm-is-fixed')) {
        bar.classList.remove('cm-is-fixed');
      }
      placeholder.style.height = '0px';
    };

    const onScroll = () => {
      if (!mq.matches) {
        disableFixed();
        return;
      }

      // If any drawer/menu is open, do NOT keep the bar fixed above it
      if (anyDrawerOpen()) {
        disableFixed();
        return;
      }

      const headerBottom = readHeaderBottom();
      document.documentElement.style.setProperty('--cm-mobile-sticky-top', `${headerBottom}px`);

      const shouldFix = window.scrollY > (startY - headerBottom);

      if (shouldFix) {
        bar.classList.add('cm-is-fixed');

        // Always keep placeholder height in sync (prevents covering products)
        placeholder.style.height = `${bar.offsetHeight}px`;
      } else {
        disableFixed();
      }
    };

    // Init
    computeStart();
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', () => {
      // Recompute on orientation / resize
      disableFixed();
      computeStart();
      onScroll();
    });

    mq.addEventListener?.('change', () => {
      disableFixed();
      computeStart();
      onScroll();
    });

    // When <details> opens/closes, update immediately (menu/drawers)
    document.addEventListener(
      'toggle',
      () => {
        if (bar.classList.contains('cm-is-fixed')) {
          placeholder.style.height = `${bar.offsetHeight}px`;
        }
        onScroll();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

function initSmoothExpandableElements(scope = document) {
  const expandableElements = scope.querySelectorAll(
    '.product__accordion details, .accordion details, .facets__disclosure-vertical, .facets__disclosure-has-popup'
  );

  expandableElements.forEach((details) => {
    if (details.dataset.smoothInit === 'true') return;

    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content, .facets__display');

    if (!summary || !content) return;

    details.dataset.smoothInit = 'true';

    if (details.open) {
      content.style.height = 'auto';
      content.style.opacity = '1';
    } else {
      content.style.height = '0px';
      content.style.opacity = '0';
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.classList.contains('is-animating')) return;

      if (details.open) {
        closeExpandable(details, content);
      } else {
        openExpandable(details, content);
      }
    });
  });
}

function openExpandable(details, content) {
  details.classList.add('is-animating');
  details.open = true;

  content.style.height = '0px';
  content.style.opacity = '1';

  requestAnimationFrame(() => {
    content.style.height = content.scrollHeight + 'px';
  });

  const onEnd = (event) => {
    if (event.propertyName !== 'height') return;

    content.style.height = 'auto';
    details.classList.remove('is-animating');
    content.removeEventListener('transitionend', onEnd);
  };

  content.addEventListener('transitionend', onEnd);
}

function closeExpandable(details, content) {
  details.classList.add('is-animating');

  content.style.height = content.scrollHeight + 'px';
  content.style.opacity = '1';

  requestAnimationFrame(() => {
    content.style.height = '0px';
    content.style.opacity = '0';
  });

  const onEnd = (event) => {
    if (event.propertyName !== 'height') return;

    details.open = false;
    details.classList.remove('is-animating');
    content.removeEventListener('transitionend', onEnd);
  };

  content.addEventListener('transitionend', onEnd);
}

document.addEventListener('DOMContentLoaded', () => {
  initSmoothExpandableElements();
});

document.addEventListener('shopify:section:load', (event) => {
  initSmoothExpandableElements(event.target);
});
